import React from 'react';

class Footer extends React.Component {
	render() {
		return (
            <footer>
                <div className="container">
                    <div className="footer-content">
                        <div className="footer-1">
                            <span className="barlow-li-it">*Website created by <a className="barlow-me" href="https://www.behance.net/HolyCone" rel="noopener">Julie Flogeac</a>, developed by <a className="barlow-me" href="http://corentinbac.com" rel="noopener">Corentin Bac</a></span>
                        </div>
                        <div className="footer-2">
                            <span className="barlow-me">viviane.korkmaz@gmail.com</span>&nbsp;&nbsp;<a href="tel:+33699850539">(+33) 699 850 539</a> <a href="https://www.instagram.com/la_roulotte_/" target="_blank" rel="noopener"><img className="instagram-logo" src="/assets/svg/instagram-logo.svg" width="13" height="13" alt=""/></a><a href="https://www.behance.net/LaRoulotte" target="_blank" rel="noopener"><img className="behance-logo" src="/assets/svg/behance-logo.svg" width="15" height="10" alt=""/></a>
                        </div>
                    </div>
                </div>
            </footer>
		);
	}
}

export default Footer;


// WEBPACK FOOTER //
// ./src/components/Footer.js